/*@flow*/
import history from 'lib/history';

export default function isPath(path: string): %checks {
  return history.getCurrentLocation().pathname === path;
}
